import toast from "react-hot-toast";
import * as api from "../Api";

export const getAllBranchAdvice = () => async (dispatch) => {
  try {
    const { data } = await api.getBranchAdvice();
    dispatch({ type: "GET_BRANCH_ADVICE", payload: data });
  } catch (error) {}
};

export const clearBranchAdvice = (id, postData) => async (dispatch) => {
  let clearingId;
  try {
    clearingId = toast.loading("submitting....");
    await api.updateAdvice(id, postData);
    dispatch({ type: "CLEAR_BRANCH_ADVICE", payload: id });
    toast.remove(clearingId);
    toast.success("data successfully patched");
  } catch (error) {
    toast.remove(clearingId);
    toast.error(error.message);
  }
};
